import { useGame } from '@/app/providers/GameContextProvider'
import { GameStep } from '@/lib/types/common/GameStep';
import React, { useState, useEffect } from 'react'


const ServerInfoRound = () => {
	const { gameState } = useGame();
	// Detect endless mode (gameMode is on gameState, not gameSettings)
	const isInfinite = gameState?.isEffectivelyEndless || gameState?.isEffectivelyFight;
	// Progress logic
	const progress = isInfinite ? 1 : (gameState ? ((gameState.currentRound - 1) / gameState.maxRounds) : 0);
	let nextProgress = isInfinite ? 1 : (gameState ? (gameState.currentRound / gameState.maxRounds) : 0);
	let isFinalBlink = false;
	if (!isInfinite && gameState && gameState.currentRound === gameState.maxRounds) {
		nextProgress = 1;
		isFinalBlink = true;
	}
	const [blinkOpacity, setBlinkOpacity] = useState(0);

	useEffect(() => {
		if (gameState) {
			const interval = setInterval(() => {
				const time = Date.now() / 1000;
				const blink = (Math.sin(time * 4) + 1) / 2;
				setBlinkOpacity(blink);
			}, 50);
			return () => clearInterval(interval);
		} else {
			setBlinkOpacity(0);
		}
	}, [gameState]);

	const radius = 20;
	const center = 25;

	// Helper to get coordinates on the circle
	const getCoords = (progress: number) => {
		const angle = (progress * 2 * Math.PI) - Math.PI / 2;
		return [center + radius * Math.cos(angle), center + radius * Math.sin(angle)];
	};

	const [baseX, baseY] = getCoords(progress);
	const [nextX, nextY] = getCoords(nextProgress);

	// Large arc flag logic
	const baseLargeArcFlag = progress > 0.5 ? 1 : 0;

	const CIRCLE_SIZE = 20;

	if (gameState?.gameStep !== GameStep.GUESSING && gameState?.gameStep !== GameStep.RESULT) return null;


	return (
		<div className="flex items-center gap-2">
			<svg width={CIRCLE_SIZE} height={CIRCLE_SIZE} viewBox="0 0 50 50" className='rounded-xl'>
				<defs>
					<filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
						<feDropShadow dx="-3" dy="3" stdDeviation="2" flood-color="#854d0e" flood-opacity="0.6" />
						<feDropShadow dx="3" dy="3" stdDeviation="2" flood-color="#854d0e" flood-opacity="0.6" />
						<feDropShadow dx="3" dy="-3" stdDeviation="2" flood-color="#854d0e" flood-opacity="0.6" />
						<feDropShadow dx="-3" dy="-3" stdDeviation="2" flood-color="#854d0e" flood-opacity="0.6" />
					</filter>
				</defs>
				<circle cx={center} cy={center} r={radius} fill="#f8f0bf" fillOpacity="0.1" stroke="#f8f0bf" strokeWidth="3" strokeOpacity="0.5" filter="url(#shadow)" />
				{/* Draw completed progress or full circle for endless */}
				{progress > 0 && (
					isInfinite ? (
						<>
							<path
								d={`M ${center} ${center} L ${center} 5 A ${radius} ${radius} 0 1 1 ${center} ${center + radius} Z`}
								fill="#f8f0bf"
							/>
							<path
								d={`M ${center} ${center} L ${center} ${center + radius} A ${radius} ${radius} 0 1 1 ${center} 5 Z`}
								fill="#f8f0bf"
							/>
						</>
					) : (
						<path
							d={`M ${center} ${center} L ${center} 5 A ${radius} ${radius} 0 ${baseLargeArcFlag} 1 ${baseX} ${baseY} Z`}
							fill="#f8f0bf"
						/>
					)
				)}
				{/* Draw blinking next segment, always from top; on last round, full circle as two half-arcs */}
				{!isInfinite && blinkOpacity > 0 && gameState && (
					isFinalBlink ? (
						<>
							<path
								d={`M ${center} ${center} L ${center} 5 A ${radius} ${radius} 0 1 1 ${center} ${center + radius} Z`}
								fill="#f8f0bf"
								opacity={blinkOpacity}
							/>
							<path
								d={`M ${center} ${center} L ${center} ${center + radius} A ${radius} ${radius} 0 1 1 ${center} 5 Z`}
								fill="#f8f0bf"
								opacity={blinkOpacity}
							/>
						</>
					) : (
						<path
							d={`M ${center} ${center} L ${center} 5 A ${radius} ${radius} 0 ${(nextProgress > 0.5 ? 1 : 0)} 1 ${nextX} ${nextY} Z`}
							fill="#f8f0bf"
							opacity={blinkOpacity}
						/>
					)
				)}
			</svg>
			<div className="text-xs xl:text-base">
				{isInfinite
					? `Round ${gameState?.currentRound}`
					: `Round ${gameState?.currentRound}/${gameState?.gameSettings.maxRounds}`
				}
			</div>
		</div>
	);
}

export default ServerInfoRound